import { render } from "./SubscribeButton.vue?vue&type=template&id=5b559b1a&scoped=true"
import script from "./SubscribeButton.vue?vue&type=script&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&lang=js"

import "./SubscribeButton.vue?vue&type=style&index=0&id=5b559b1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b559b1a"

export default script